import SwaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'   

export function loadSwagger(spec) {

    SwaggerUI({
        dom_id: '#swagger-ui-container',
        spec: spec,
    })
}




// WEBPACK FOOTER //
// ./src/services/swagger-ui.js